import actionTypes from 'src/modules/redux/actionTypes'

export const setFavouriteAdsLoading = (status = 'Published', isLoading) => ({
  type: actionTypes.SET_PROFILE_FAVOURITE_ADS_LOADING,
  payload: {status, isLoading}
})